import React from 'react';

import ItemFormLeft from './ItemFormLeft';
import ItemFormRight from './ItemFormRight';

const ItemForm = props => {
  const { firstChild } = props;
  if (firstChild) {
    return <ItemFormLeft />;
  }

  return <ItemFormRight />;
};

export default ItemForm;
